import React, { useEffect, useState } from 'react';
import COTabs from 'shared/components/COTabs';
import DashboardContainer from 'views/Dashboard/DashboardContainer';
import styles from './Products.module.scss';
import { ReactComponent as Add } from 'assets/icons/add.svg';
import {
  BrandPageProps,
  ButtonProps,
  TabsIndex,
  TabsKeys,
} from 'enums/ProductsViewEnums';
import COButton from 'shared/components/COButton';
import { useLocation, useNavigate } from 'react-router-dom';
import { getTabs } from './ProductsHelpers';
import CreateProductModal from 'shared/components/CreateProductModal';
import { DataMappingProps } from 'enums/CreateProductStageNavigationBarEnums';
import { FlowContainerConstants } from 'views/FlowContainer/FlowContainerConstants';
import { EmissionDataContext } from 'context/EmissionDataContext';
import ValueChainService from 'services/ValueChainService/valuechain.service';
import ProcessingFacilityModal from 'shared/components/Products/ProcessingFacilityModal';
import { useParentOrganizationContext } from 'context/ParentOrganisationContext';

const ProductsView: React.FC = () => {
  const { fetchProcessingFacilities, processingFacilityList } =
    ValueChainService();
  const { organizationData } = useParentOrganizationContext();
  const [createProcessingFacility, setCreateProcessingFacility] =
    useState<boolean>(false);
  const location = useLocation();
  const navigate = useNavigate();
  const user = localStorage.getItem('userDetails');
  let parsedUser;
  if (user !== null) {
    parsedUser = JSON.parse(user);
  }
  const {
    STAGE_1_TOTAL_EMISSION,
    STAGE_2_TOTAL_EMISSION,
    STAGE_3_TOTAL_EMISSION,
  } = FlowContainerConstants;

  const {
    setStage1Data,
    setStage2Data,
    setStage3Data,
    setStage1Total,
    setStage2Total,
    setStage3Total,
  } = React.useContext(EmissionDataContext);

  useEffect(() => {
    fetchProcessingFacilities();
  }, []);

  const [showBrandModal, setShowBrandModal] = useState<boolean>(false);

  const [createProductModal, setCreateProductModal] =
    React.useState<boolean>(false);

  const isActiveTab = (key: string) => {
    let currentPage = location.pathname.split('/').length - 1;
    return location.pathname.split('/')[currentPage] === key;
  };

  const currentTab = () => {
    let currentUrl = location.pathname.split('/').length - 1;
    return location.pathname.split('/')[currentUrl];
  };
  const handleTabChange = (key: string) => {
    if (key === TabsKeys.ALL_PRODUCTS) {
      navigate(`/${TabsKeys.ALL_PRODUCTS}`);
    } else {
      navigate(`/${TabsKeys.ALL_PRODUCTS}/${key}`, { replace: true });
    }
  };

  const tabComponents = getTabs({
    isActiveTab,
    handleTabChange,
    showBrandModal,
    setShowBrandModal,
    processingFacilityList,
    setCreateProcessingFacility,
  });

  const handleCancelCreateProductModal = () => {
    setCreateProductModal(false);
  };
  const handleConfirmCreateProductModal = () => {
    setCreateProductModal(false);
  };
  const handleOpenCreateProductModal = () => {
    if (
      processingFacilityList?.length &&
      organizationData?.organization?.name
    ) {
      setCreateProductModal(true);
    } else {
      setCreateProcessingFacility(true);
    }
  };
  const handleProcessingFacilityModalClose = () =>
    setCreateProcessingFacility(false);
  const handleNavigateCreateProduct = () => {
    localStorage.removeItem('create-product');
    handleOpenCreateProductModal();
  };

  const showBCreaterandModal = () => {
    setShowBrandModal(true);
  };

  useEffect(() => {
    localStorage.removeItem('create-product');
    localStorage.removeItem(DataMappingProps.STAGE_1);
    localStorage.removeItem(DataMappingProps.STAGE_2);
    localStorage.removeItem(DataMappingProps.STAGE_3);
    localStorage.removeItem(STAGE_1_TOTAL_EMISSION);
    localStorage.removeItem(STAGE_2_TOTAL_EMISSION);
    localStorage.removeItem(STAGE_3_TOTAL_EMISSION);
    setStage1Data([]);
    setStage2Data([]);
    setStage3Data({});
    setStage1Total(0);
    setStage2Total(0);
    setStage3Total(0);
  }, []);

  const isBrand = isActiveTab(TabsIndex.BRANDS);

  return (
    <>
      {createProductModal && (
        <CreateProductModal
          showModalState={createProductModal}
          handleModalCancel={handleCancelCreateProductModal}
          handleModalConfirm={handleConfirmCreateProductModal}
          userId={Number(parsedUser.id)}
          isCreate={true}
        />
      )}

      <DashboardContainer>
        <div className={styles.topContainer}>
          <div className={styles.topLeftContainer}>
            <h1>{BrandPageProps.PAGE_TITLE}</h1>
          </div>

          <div className={styles.topRightContainer}>
            <COButton
              onClick={
                isBrand ? showBCreaterandModal : handleNavigateCreateProduct
              }>
              <Add />{' '}
              {isBrand ? ButtonProps.CREATE_BRAND : ButtonProps.CREATE_PRODUCT}
            </COButton>
          </div>
        </div>
        <div className={styles.secondRowContainer}>
          <div className={styles.tabsContainer}>
            <COTabs components={tabComponents} activeKey={currentTab()} />
          </div>
        </div>
        <ProcessingFacilityModal
          modalOpen={createProcessingFacility}
          handleClose={handleProcessingFacilityModalClose}
        />
      </DashboardContainer>
    </>
  );
};

export default ProductsView;
